export default {
      id: "network-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#network",
      toString: function () {
        return this.url;
      }
    }